
export class AppConfig {
    readonly dateFormatOptions: Intl.DateTimeFormatOptions;
    readonly dateTimeFormatOptions: Intl.DateTimeFormatOptions;

    constructor() {
        this.dateFormatOptions = { year: 'numeric', month: 'short', day: 'numeric' };
        this.dateTimeFormatOptions = { year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', hour12: true, hourCycle: 'h12', minute: 'numeric', second: 'numeric' };
    }
}

export var _config: AppConfig;
export default function config(): AppConfig {
    if (!_config)
        _config = new AppConfig();

    return _config;
}